"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMiniBagConfiguration = exports.miniBagConfigurationContext = exports.MiniBagConfigurationContextProvider = void 0;
var _react = require("react");
const miniBagConfigurationContext = exports.miniBagConfigurationContext = /*#__PURE__*/(0, _react.createContext)({
  miniBagConfiguration: undefined,
  isMiniBagConfigurationLoading: false
});
const MiniBagConfigurationContextProvider = exports.MiniBagConfigurationContextProvider = miniBagConfigurationContext.Provider;
const useMiniBagConfiguration = () => (0, _react.useContext)(miniBagConfigurationContext);
exports.useMiniBagConfiguration = useMiniBagConfiguration;
